import styled from "styled-components"
import { ContainerWithColor } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/ContainerWithColor/ContainerWithColor"

export const Container = styled(ContainerWithColor)`
    /* Match POC design specifications */
    background-color: white;
    border-radius: 16px;
    border: 1px solid #e9ecef;
    box-shadow: 0px 2px 12px -4px rgba(0, 0, 0, 0.12);

    /* Flex layout for content */
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;

    /* Width and centering (match POC unit semantics using rem) */
    width: 100%;
    max-width: 45rem; /* 45rem = 720px at 16px root */
    margin: 0 auto;

    /* Padding - 2rem desktop, 1.5rem mobile (POC unit semantics) */
    padding: 40px;

    .gotv-v2-countdown-unavailable {
        font-size: 0.875rem;
        text-align: center;
        color: var(--plum-color-fg-subtle, #6c757d);
    }

    @media (max-width: 768px) {
        padding: 1.5rem;
    }
`

export const NoElectionsWrapper = styled.div`
    width: 100%;
    margin: 1.5rem 0 0;
    text-align: center;
`

export const NoElectionsTitle = styled.h2`
    margin: 0;
    color: var(--plum-black, #000);
    text-align: center;
    font-size: var(--plum-font-xl, 24px);
    font-style: normal;
    font-weight: 500;
    line-height: var(--plum-font-3xl, 32px);
`

export const NoElectionsSubtitle = styled.p`
    margin: 0.75rem 0 0;
    color: var(--plum-gray-7, #495057);
    font-size: var(--plum-font-md, 16px);
    font-style: normal;
    font-weight: 400;
    line-height: var(--plum-font-lg, 20px);
    letter-spacing: var(--plum-letter-spacing-xxs, 0.1px);
`
